import { render, staticRenderFns } from "./IdCardCome.vue?vue&type=template&id=44a8bd87&scoped=true"
import script from "./IdCardCome.vue?vue&type=script&lang=js"
export * from "./IdCardCome.vue?vue&type=script&lang=js"
import style0 from "./IdCardCome.vue?vue&type=style&index=0&id=44a8bd87&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8bd87",
  null
  
)

export default component.exports